import { watch } from "vue"
import { createVuetify } from "vuetify"
import * as components from "vuetify/components"
import * as directives from "vuetify/directives"
import { aliases, mdi } from "vuetify/iconsets/mdi-svg"
import { VFileUpload } from "vuetify/labs/VFileUpload"
import { locale } from "./runtime"

// eslint-disable-next-line no-unassigned-import
import "vuetify/dist/vuetify.css" // ??
// eslint-disable-next-line no-unassigned-import
import "@effect-app/vue-components/reset.css"

export default defineNuxtPlugin((nuxtApp) => {
  const vuetify = createVuetify({
    components: { ...components, VFileUpload },
    directives,
    // Align Vuetify with the app locale (same ref makeIntl uses): drives i18n
    // of built-in components and the decimal separator ("," for de) that
    // VNumberInput accepts and renders.
    locale: {
      locale: locale.value,
      fallback: "en"
    },
    icons: {
      defaultSet: "mdi",
      aliases,
      sets: {
        mdi
      }
    },
    theme: {
      defaultTheme: useRuntimeConfig().public.theme || "hausfux",
      themes: {
        light: {
          colors: {
            primary: "#F47B22",
            contrast: "#FFF"
          }
        },
        dark: {
          colors: {
            primary: "#F47B22"
          }
        },
        blizzz: {
          colors: {
            primary: "#FFED00",
            contrast: "#58585a"
          }
        },
        alfa: {
          colors: {
            primary: "#E4001B",
            contrast: "#232323"
          }
        },
        hecht: {
          colors: {
            primary: "#e4a700ff",
            contrast: "#232323"
          }
        },
        hausfux: {
          colors: {
            primary: "#F47B22",
            secondary: "#3d464c",
            contrast: "#FFF"
          }
        }
      }
    }
  })

  nuxtApp.vueApp.use(vuetify)

  // Keep Vuetify in sync if the app locale changes at runtime
  watch(locale, (l) => {
    vuetify.locale.current.value = l
  })
})
